import React, { Fragment, useState, useEffect } from "react";
import FavoriteIcon from "@mui/icons-material/Favorite";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import TextField from "@mui/material/TextField";
import LoadingButton from "@mui/lab/LoadingButton";
import Typography from "@mui/material/Typography";
import {
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  Grid,
  Box,
} from "@mui/material";
// import {
//   Menu,
//   MenuItem,
// } from "@material-ui/core"
import { MoreVert, Delete, Edit } from "@mui/icons-material";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import { getInstance } from '../config/token';
import {
  Button,
  Modal,
} from "react-bootstrap";


export default function NoteItem({ note, onDelete, onUpdate }) {
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [noteTitle, setNoteTitle] = useState(note.title);
  const [noteContent, setNoteContent] = useState(note.note);
  const [menuOpened, setMenuOpened] = useState(false);
  const [anchor, setAnchor] = useState(null);
  const [isLiked, setIsLiked] = useState(0);
  const [favoriteButtonDisabled, setFavoriteButtonDisabled] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);

  // useEffect(() => {
  //   setNoteTitle(note.title);
  //   setNoteContent(note.content);
  //   setIsLiked(note.favorited);
  // }, [note]);


  const deleteNoteOnClick = async (id) => {
    let requestObj = {
      id: id
    }
    setButtonDisabled(true);
    let config = getInstance('POST', `/api/delete_note`, requestObj);
    axios(config)
      .then((res) => {
        setButtonDisabled(false)
        setDeletePopup(false)
        onUpdate()

      })
      .catch((err) => {
        setButtonDisabled(false)
        let msg = "Something went wrong!"
        toast.error(msg, {
          position: "top-right",
        });
      });
  };

  const upddateNoteFavorite = async () => {
    let requestObj = {
      id: note.id,
      favourite: !note.user_sticky_notes[0].is_favourite
    }
    setFavoriteButtonDisabled(true);
    let config = getInstance('POST', `/api/note_favourite`, requestObj);
    axios(config)
      .then((res) => {
        setFavoriteButtonDisabled(false)
        // setDeletePopup(false)
        onUpdate()

      })
      .catch((err) => {
        setFavoriteButtonDisabled(false)
        let msg = "Something went wrong!"
        toast.error(msg, {
          position: "top-right",
        });
      });
    // setFavoriteButtonDisabled(true);
    // const response = await updateFavorited(note.id, !isLiked);
    // const data = await response.data;
    // onUpdate();

    // if (data.success) {
    //   const currentState = data.note.favorited;
    //   setIsLiked(currentState);
    // }
    // setFavoriteButtonDisabled(false);
  };

  const editedNote = async () => {
    let errFlag = false;
    if (noteTitle == "") {
      errFlag = true;
      toast.error("title is required.", {
        position: "top-right",
      });
    } else if (noteContent == "") {
      errFlag = true;
      toast.error("note is required.", {
        position: "top-right",
      });
    }

    if (!errFlag) {
      let requestObj = {
        id: note.id,
        note: noteContent,
        title: noteTitle
      }
      setButtonDisabled(true);
      let config = getInstance('POST', `/api/edit_note`, requestObj);
      axios(config)
        .then((res) => {
          setButtonDisabled(false)
          setIsEdit(!setIsEdit);
          // setNoteContent("");
          // setNoteTitle("");
          // props.closeNotePopup()
          onUpdate()

        })
        .catch((err) => {
          setButtonDisabled(false)
          let msg = "Something went wrong!"
          toast.error(msg, {
            position: "top-right",
          });
        });
    }
  };

  const getDate = (date) => moment(date).format("DD.MM.yyyy");
  const getTime = (date) => moment(date).format("HH.mm");
  let assignedUserName = ''
  let readUserName = ''
  if (note && note.assignedUser && note.assignedUser.length) {
    for (let i = 0; i < note.assignedUser.length; i++) {
      if (assignedUserName) {
        assignedUserName = assignedUserName + ', ' + note.assignedUser[i].user.first_name + ' ' + note.assignedUser[i].user.last_name
      } else {
        assignedUserName = note.assignedUser[i].user.first_name + ' ' + note.assignedUser[i].user.last_name
      }
      if (note.assignedUser[i].is_read) {
        if (readUserName) {
          readUserName = readUserName + ', ' + note.assignedUser[i].user.first_name + ' ' + note.assignedUser[i].user.last_name
        } else {
          readUserName = note.assignedUser[i].user.first_name + ' ' + note.assignedUser[i].user.last_name
        }
      }

    }
  }

  return (
    <Fragment>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Card sx={{ position: "relative", height: "100%", border : "1px solid #3D455A", borderRadius : "0.75rem" }} fullWidth>
        <CardHeader
          sx={{ position: "absolute", right: 0, zIndex: 1 }}
          disableTypography
          action={
            <div>
              {!isEdit && (
                <>
                  <IconButton
                    onClick={() => upddateNoteFavorite()}
                    disabled={favoriteButtonDisabled}
                    sx={{ color: note.user_sticky_notes[0].is_favourite ? "red" : "gray" }}
                    size="small"
                  >
                    <FavoriteIcon />
                  </IconButton>
                  <IconButton
                    onClick={(e) => {
                      setMenuOpened(true);
                      setAnchor(e.currentTarget);
                    }}
                  >
                    <MoreVert />
                  </IconButton>
                </>
              )}

              <Menu
                id="basic-menu"
                anchorEl={anchor}
                open={menuOpened}
                onClose={() => setMenuOpened(false)}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  onClick={() => {
                    setIsEdit(!isEdit);
                    setMenuOpened(false);
                  }}
                >
                  <Edit sx={{ mr: 2 }} /> Edit
                </MenuItem>
                <MenuItem onClick={() => {
                  setDeletePopup(true);
                  setMenuOpened(false);
                }}
                >
                  <Delete sx={{ mr: 2 }} /> Delete
                </MenuItem>
              </Menu>
            </div>
          }
        />
        <CardContent justifyContent="space-between" sx={{ height: "100%" }}>
          {!isEdit ? (
            <Typography
              noWrap
              gutterBottom
              variant="h5"
              component="div"
              sx={{ mr: "70px" }}
            >
              {noteTitle}
            </Typography>
          ) : (
            // <TextField
            //   sx={{ mb: 3 }}
            //   fullWidth
            //   variant="outlined"
            //   label="Title"
            //   value={noteTitle}
            //   onChange={(e) => setNoteTitle(e.target.value)}
            // />
            <div className="form-group">
              <label className="text-black font-w500">Title</label>
                <input
                  type="text"
                  name="title"
                  className="form-control form-border-color"
                  maxLength={255}
                  required
                  value={noteTitle}
                  onChange={(e) => setNoteTitle(e.target.value)}
                />

              </div>
          )}
          {!isEdit ? (
            <>
              <Grid container flexDirection="column" sx={{ height: "100%" }}>
                <Typography
                  variant="body2"
                  gutterBottom
                  color="text.secondary"
                  sx={{
                    minHeight: 350,
                    maxHeight: 350,
                    overflowY: "scroll",
                    mb: "36px",
                    color: "#111111",
                    fontWeight: "500",
                    fontSize: "1rem",
                    whiteSpace: "pre-line"
                  }}
                >
                  {noteContent}
                </Typography>
                <Box sx={{ position: "relative", bottom: "12px", left: "12px", overflowY : "auto", maxHeight : "100px" }}>
                <Typography
                    variant="caption"
                    display="block"
                    sx={{ color: "#FE634E", fontSize: "1rem" }}
                  >
                    Updated : {note.updatedAt !== undefined && note.updatedAt !== null && note.updatedAt !== "" ? new Date(note.updatedAt).toLocaleString('en-US', { timeZone: 'America/New_York' }) : "-"}
                  </Typography>
                  <Typography
                    variant="caption"
                    display="block"
                    sx={{ color: "#111111", fontSize: "1rem" }}
                  >
                    Created By : {note.user && note.user.first_name ? note.user.first_name + ' ' + note.user.last_name : "-"}
                  </Typography>
                  <Typography
                    variant="caption"
                    display="block"
                    sx={{ color: "#111111", fontSize: "1rem" }}
                  >
                    {/* {getDate(note.updatedAt)} */}
                    Assigned To : {assignedUserName}
                  </Typography>
                  <Typography
                    variant="caption"
                    display="block"
                    sx={{ color: "#111111", fontSize: "1rem" }}
                  >
                    {/* {getDate(note.updatedAt)} */}
                    Read By : {readUserName}
                  </Typography>
                </Box>
              </Grid>
            </>
          ) : (
            // <TextField
            //   sx={{ maxHeight: 350, overflowY: "scroll", pt: 1 }}
            //   fullWidth
            //   variant="standard"
            //   label="Content"
            //   multiline
            //   value={noteContent}
            //   onChange={(e) => setNoteContent(e.target.value)}
            // />
            <div className="form-group">
              <label className="text-black font-w500">Note</label>
            <textarea
                  name="note"
                  id="textarea"
                  cols={30}
                  rows={10}
                  // maxLength={2000}
                  className="form-control form-border-color"
                  // defaultValue={""}
                  value={noteContent}
                  required
                  onChange={(e) => setNoteContent(e.target.value)}
                />
                </div>
          )}
          {isEdit && (
            <LoadingButton
              sx={{
                mt: 2,
              }}
              fullWidth
              loading={buttonDisabled}
              variant="outlined"
              size="medium"
              onClick={() => editedNote()}
            >
              Save
            </LoadingButton>
          )}
        </CardContent>
      </Card>
      <Modal
        show={deletePopup}
        // onHide={() => this.setState({ cameraModal: false })}
        className="modal fade"
        id="cameraModal"
      >
        <div className="">
          <div className="modal-header">
            <h5 className="modal-title">Delete Note</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              onClick={() => deletePopup(false)}
            >
              <span>×</span>
            </button>
          </div>

          <div className="modal-body">
            <form
              className="comment-form"
              onSubmit={(e) => {
                e.preventDefault();
                // setNewEvent(false);
              }}
            >
              <div>
                <div className="form-group">
                  <div className="form-group">
                    <strong style={{ color: "black" }}>Are you sure you want to delete this note.</strong>
                  </div>
                </div>
                <div className="form-group" style={{ textAlign: "center" }}>

                  <input
                    type="submit"
                    value="No"
                    className="btn btn-primary"
                    onClick={() => setDeletePopup(false)}

                  />
                  <input
                    disabled={buttonDisabled}
                    type="submit"
                    value="Delete"
                    className="btn btn-danger"
                    onClick={() => deleteNoteOnClick(note.id)}
                    style={{ marginLeft: "10px" }}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </Fragment>
  );
}
